import { LinkHandlerContext } from 'components/Contexts';

const PloneLink = ({children, ...props}) => {
    const handleClick = (callback, e) => {
        e.preventDefault();
        callback(props.item["@id"]);
    };

    const item = props.item;

    return (
        <LinkHandlerContext.Consumer>
            { context => (
                <a href={ item["@id"] }
                   onClick={ (e => handleClick(context.openLink, e)) }
                >
                    { children }
                </a>
            )}
        </LinkHandlerContext.Consumer>
    )
};

export default PloneLink;


// WEBPACK FOOTER //
// ./components/PloneLink.jsx